module.exports = __webpack_public_path__ + "img/service-8-4.6b838c38.jpeg";